import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';

import { useCallback } from 'react';

import { useCardOfferContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { CardContent } from '../CardContent';
import { CardGalleryContainer } from '../CardGallery';
import { CardLayout } from '../CardLayout';
import { CardThumbnailsContainer } from '../CardThumbnails';
import { Controls } from '../Controls';
import { ErrorLogContainer } from '../ErrorLogComponent';
import { PublisherCard } from '../PublisherCard';
import { VASBlockContainer } from '../VASBlock';

export const Card = memoWithDisplayName(() => {
  const {
    data: {
      url,
      extendedProperties: { offerServices },
      areaParts,
    },
    id: offerId,
  } = useCardOfferContext();
  const isShortListing = useListingLayoutIsShortSelector();
  const { setOfferVisited } = useVisitedOffersContext();

  const caForCard = useCAForCard();

  const handleCardClick = useCallback(() => {
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_card' });

    setOfferVisited(offerId);

    window.open(url, '_blank');
  }, [caForCard, setOfferVisited, offerId, url]);

  return (
    <ErrorLogContainer level="error">
      <CardLayout
        content={<CardContent />}
        controls={<Controls />}
        gallery={<CardGalleryContainer />}
        isMulti={!!areaParts}
        isShortListing={isShortListing}
        isTop3={!!offerServices?.isTop3}
        publisher={<PublisherCard />}
        testId={`card.${offerId}`}
        thumbnails={<CardThumbnailsContainer />}
        vas={<VASBlockContainer />}
        onClick={handleCardClick}
      />
    </ErrorLogContainer>
  );
}, 'Card');
